var $d2aa7abea627cafa$exports = {};
$d2aa7abea627cafa$exports = {
    "Empty": `Prazno`
};


export {$d2aa7abea627cafa$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
